import { useQuery } from '@tanstack/react-query';
import { getPosts, getPublicPosts } from '../api/postApi';
import { useAuthContext } from '../../../components/AuthProvider';

export function usePosts() {
  const { isAuthenticated } = useAuthContext();
  
  return useQuery({
    queryKey: ['posts', { isAuthenticated }],
    queryFn: () => isAuthenticated ? getPosts() : getPublicPosts(),
  });
}